import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { SpaContext } from '../Classes/spacontext';
import { ComplianceSettings, NotificationSettingsService } from '../Services/api/v2/notificationSettings.service';
import { SpaEventService } from '../Services/spaEvents.service';

@Component({
	standalone: false,
	selector: 'visiba-notification-compliance',
	template: `
		<div class="notificationComplianceContainer" *ngIf="notificationSettings">
			<ng-container *ngIf="showConfirmationDialog">
				<h2 class="title">{{ 'Notification.Approval.Dialog.Title' | translate }}</h2>
				<p>
					{{ 'Notification.Approval.Dialog.Body' | translate }}
				</p>
				<div class="row">
					<button (click)="emitNotificationSettings(false)" class="btn danger">
						{{ 'Notification.Approval.Dialog.Continue' | translate }}
					</button>
					<button (click)="showSettingsView()" class="btn">{{ 'Notification.Approval.Dialog.GoBack' | translate }}</button>
				</div>
			</ng-container>
			<ng-container *ngIf="!showConfirmationDialog">
				<h2 class="title">{{ 'Notification.Approval.Title' | translate }}</h2>
				<p
					class="infoText"
					[innerHtml]="
						'Notification.Approval.Body' | translate: { customerName: spaContext.unitConfig.LicenceHolder.DisplayName } | safeHtml
					"
				></p>
				<div class="row toggleContainer">
					<span class="bold">{{ 'Notification.Approval.ApproveEmail' | translate }}</span>
					<toggle-switch
						(onChange)="setNotificationSetting('email', $event)"
						[value]="notificationSettings.AllowEmail"
					></toggle-switch>
				</div>
				<div class="row toggleContainer">
					<span class="bold">{{ 'Notification.Approval.ApproveSms' | translate }}</span>
					<toggle-switch (onChange)="setNotificationSetting('sms', $event)" [value]="notificationSettings.AllowSms"></toggle-switch>
				</div>
				<div class="row" *ngIf="hasError">
					<span class="error">{{ 'Common.Error.Retry' | translate }}</span>
				</div>
				<div class="row">
					<button (click)="emitNotificationSettings()" class="btn sendButton">{{ 'Common.Button.Save' | translate }}</button>
				</div>
			</ng-container>
		</div>
	`,
	styleUrls: ['../Css/Components/notificationCompliance.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class NotificationComplianceComponent {
	@Output() public onSubmit = new EventEmitter();
	@Output() public onCancel = new EventEmitter();
	public showConfirmationDialog = false;
	public hasError = false;

	@Input() public notificationSettings: ComplianceSettings | null = null;

	constructor(
		private spaEventsService: SpaEventService,
		private notificationSettingsService: NotificationSettingsService,
		public spaContext: SpaContext,
	) {}

	public emitNotificationSettings(checkIfIgnoredSettings = true) {
		if (checkIfIgnoredSettings && (!this.notificationSettings.AllowSms || !this.notificationSettings.AllowEmail)) {
			this.showConfirmationDialog = true;
			return;
		}
		this.hasError = false;

		this.notificationSettingsService
			.putComplianceSettings({ allowEmail: this.notificationSettings.AllowEmail, allowSms: this.notificationSettings.AllowSms })
			.subscribe(
				(response) => {
					this.spaEventsService.onNotificationComplianceCompleted.emit();
				},
				(error) => {
					this.hasError = true;
				},
			);
	}

	public showSettingsView() {
		this.showConfirmationDialog = false;
		this.onCancel.emit();
	}

	public setNotificationSetting(property: string, value: boolean) {
		if (property === 'sms') {
			this.notificationSettings.AllowSms = value;
		}

		if (property === 'email') {
			this.notificationSettings.AllowEmail = value;
		}
	}
}
